<app-product-card [loading]="loading$ | async" [subtypes]="subtypes$ | async"
(subtypeSelected$)="navigateToSubtype($event)"></app-product-card>